import { useRef, useCallback, useEffect } from "react";
function useOnYReachEnd({ threshold = 0, onYReachEnd, el }) {
  const hasLoadedRef = useRef(!1), onLoadRef = useRef(onYReachEnd);
  onLoadRef.current = onYReachEnd;
  const checkScrollPosition = useCallback(() => {
    var _a;
    if (!el) return;
    const { scrollTop, scrollHeight, clientHeight } = el;
    scrollHeight - scrollTop - clientHeight <= threshold ? hasLoadedRef.current || ((_a = onLoadRef.current) == null || _a.call(onLoadRef), hasLoadedRef.current = !0) : hasLoadedRef.current && (hasLoadedRef.current = !1);
  }, [el, threshold]), checkScrollPositionRef = useRef(checkScrollPosition);
  checkScrollPositionRef.current = checkScrollPosition, useEffect(() => {
    if (!el || !onLoadRef.current) return;
    const handleScroll = () => {
      checkScrollPositionRef.current();
    };
    return el.addEventListener("scroll", handleScroll), checkScrollPositionRef.current(), () => {
      el.removeEventListener("scroll", handleScroll);
    };
  }, [el, checkScrollPosition]), useEffect(() => {
    if (!el || !onLoadRef.current) return;
    const observer = new MutationObserver(() => {
      hasLoadedRef.current = !1, checkScrollPositionRef.current();
    });
    return observer.observe(el, {
      childList: !0
      // Watch for changes in child elements
    }), () => observer.disconnect();
  }, [el]);
}
export {
  useOnYReachEnd as default
};
//# sourceMappingURL=useOnYReachEnd.js.map
